/**
 * Suivi de la recherche — EF-NAV-001. Modale non contournable : les actions de
 * consultation sont bloquées pendant une recherche.
 */

import type { JSX } from 'preact';
import { cancelSearch, searchProgress } from '../state';
import { formatCount, formatDuration } from '../format';

export function SearchProgressModal(): JSX.Element | null {
  const progress = searchProgress.value;
  if (progress === null) return null;

  const ratio = progress.totalChunks === 0 ? 0 : progress.completedChunks / progress.totalChunks;

  return (
    <div class="modal-backdrop" role="dialog" aria-modal="true" aria-label="Recherche en cours">
      <div class="modal">
        <h2 style="margin-top:0;">Recherche en cours</h2>

        <div class="progress-bar" role="progressbar" aria-valuenow={Math.round(ratio * 100)} aria-valuemin={0} aria-valuemax={100}>
          <div style={`width:${(ratio * 100).toFixed(1)}%`} />
        </div>

        <dl class="definition-list" style="margin-top:12px;">
          <div>
            <dt>Tronçons</dt>
            <dd>
              {formatCount(progress.completedChunks)} sur {formatCount(progress.totalChunks)}
            </dd>
          </div>
          <div>
            <dt>Durée écoulée</dt>
            <dd>{formatDuration(progress.consumedBudgetSeconds)}</dd>
          </div>
          <div>
            <dt>Budget restant</dt>
            <dd>{formatDuration(progress.remainingBudgetSeconds)}</dd>
          </div>
          <div>
            <dt>POI automatiques</dt>
            <dd>{formatCount(progress.automaticPoiCount)}</dd>
          </div>
        </dl>

        {progress.waitingMessage !== null ? <p class="notice">{progress.waitingMessage}</p> : null}

        <div class="actions">
          <button type="button" class="danger" onClick={cancelSearch}>
            Annuler la recherche
          </button>
        </div>
      </div>
    </div>
  );
}
